const excelMimeTypes = new Set([
  "application/vnd.ms-excel",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
]);

export const isExcelHistoryFile = (file) => {
  const contentType = (file?.type ?? file?.contentType ?? "").toLowerCase();
  const fileName = file?.origFName ?? file?.name ?? "";

  return excelMimeTypes.has(contentType) || /\.(xls|xlsx)$/i.test(fileName);
};
